import { useMutation } from 'react-query';
import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';

interface ActiveCarrierCreateData {
    carrierId: string;
    accountId?: string;
}

export const useCreateActiveCarrier = () => {
    const { currentAccountId, authToken } = useAuthSelector();
    return useMutation((data: ActiveCarrierCreateData) =>
        sdk.active_carriers.create(data.accountId ?? currentAccountId, data.carrierId, {
            authToken: authToken,
        }),
    );
};
